module.exports = __webpack_public_path__ + "a58d2211c57dedf524656898b5315ce9.jpg";